import { updateChatbotState } from "./Utils";
import {API_BASE} from "../../../services/apirest";

export const hacerConsultapaquetes = async (newMessage, setState, createChatBotMessage) => {
  try {
    const mensajeLimpio = newMessage.toLowerCase();

    if (
      !mensajeLimpio.startsWith("consultar paquetes") &&
      !mensajeLimpio.startsWith("ver paquetes")
    ) {
      return;
    }

    const response = await fetch(`${API_BASE}/paquetes.php`);
    if (!response.ok) throw new Error("Error al obtener datos de la API");

    const data = await response.json();

    if (
      data.status === "success" &&
      data.result &&
      Array.isArray(data.result.paquetes)
    ) {
      const paquetesTexto = data.result.paquetes
        .map((p, i) => {
          return `📦 *${p.nombre_paquete}*\n` +
                 `   - Descripción: ${p.descripcion || "No disponible"}\n` +
                 `   - Precio: $${p.precio_principal}\n` +
                 `   - Descuento:-$${p.descuento_principal ?? "0"}\n` +
                 `   - Meses con descuento: ${p.meses_con_descuento ?? "0"}\n` +
                 `   - Precio promoción: ${p.precio_promocion ?? "N/A"}\n` +
                 `   - Streaming: ${p.streaming ?? "No incluye"}\n`;
        })
        .join("\n\n");
    
      updateChatbotState(
        setState,
        createChatBotMessage(`Se encontraron ${data.result.paquetes.length} paquetes:\n\n${paquetesTexto}`)
      );
    } else {
      updateChatbotState(
        setState,
        createChatBotMessage("No hay paquetes disponibles en este momento.")
      );
    }
  } catch (error) {
    updateChatbotState(
      setState,
      createChatBotMessage(`Hubo un error procesando tu solicitud: ${error.message}`)
    );
  }
};
